import { useCallback } from "react";
import { embedDashboard } from "@superset-ui/embedded-sdk";

export const useSupersetHandlers = () => {
  const embedSupersetDashboard = useCallback(
    async ({ mountPointId, id, supersetDomain, token }) => {
      try {
        await embedDashboard({
          id, // given by the Superset embedding UI
          supersetDomain,
          mountPoint: document.getElementById(mountPointId), // html element in which iframe render
          fetchGuestToken: () => token,
          dashboardUiConfig: {
            // hideTitle: true,
            filters: {
              expanded: false,
            },
            // urlParams: {
            //   foo: "value1",
            //   bar: "value2",
            //   // ...
            // },
          },
          iframeSandboxExtras: [
            "allow-top-navigation",
            "allow-popups-to-escape-sandbox",
          ],
          iframeTitle: "supersetDashboard",
        });
      } catch (error) {
        console.error("Error while embedding dashboard", error);
      }
    },
    []
  );

  return { embedSupersetDashboard };
};
